import { createRouter, createWebHashHistory } from "vue-router";
import { useLanguageMixin } from "/@/mixin/languageHook.js";
const { refreshLanguage } = useLanguageMixin();

let routes = [
  {
    path: "/:path(.*)*",
    redirect: "/Default",
  },
  {
    path: "/Default",
    name: "Default",
    component: () => import("/@/views/default.vue"),
    meta: {
      title: "default",
      isLink: "",
      isHide: false,
      isKeepAlive: false,
      isAffix: true,
      isIframe: false,
    },
  },
  {
    path: "/:lang/Index",
    name: "home",
    component: () => import("/@/views/home.vue"),
    meta: {
      title: "home",
      isLink: "",
      isHide: false,
      isKeepAlive: false,
      isAffix: true,
      isIframe: false,
    },
  },
  //产品收藏列表页面
  {
    path: "/:lang/Collect/Index",
    name: "Collect/Index",
    alias: [
      "/:lang/Collect/Index",
      "/:lang/Collect/Index",
      "/:lang/Collect/Index",
      "/:lang/Collect/Index",
      "/:lang/Collect/Index",
    ],
    meta: {
      title: "收藏列表",
      cache: false,
      noFrame: true,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/Collect/index.vue"),
  },

  // 快速选型（大元）
  {
    path: "/:lang/ApplicationSelect/HouseHold/Index",
    name: "ApplicationSelect",
    meta: {
      title: "",
      cache: false,
      noFrame: true,
      noPermissionValidate: true,
      keepAlive: false,
      isLoaded: false,
    },
    component: () => import("/@/views/Corp/DYBY/QuickSelection/index.vue"),
  },

  //windows客户端下载
  {
    path: "/:lang/Download/PC/windows",
    name: "DownloadPCWindows",
    meta: {
      title: "",
      cache: false,
      noFrame: true,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/Download/PC/windows.vue"),
  },
];

// 组合路由信息
// import.meta.glob 为 vite 提供的特殊导入方式
// 它可以将模块中全部内容导入并返回一个Record对象
// 默认为懒加载模式 加入配置项 eager 取消懒加载
const modules = import.meta.glob(["./modules/*.js"], {
  eager: true,
});

Object.keys(modules).forEach((key) => {
  const module = modules[key].default;
  routes = routes.concat(module);
});

const router = createRouter({
  history: createWebHashHistory(),
  routes: routes,
});

router.beforeEach((to, from, next) => {
  let url = to.fullPath;
  refreshLanguage(url);
  next();
});

export default router;
